'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useRef } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { useSession } from '@/auth-client';
import { SignIn, SignOut } from '@/shared/components/Auth/Auth';
import { getGravatarUrl } from '@/shared/utils/gravatar.mjs';
import { useLiveDataContext } from '@/shared/providers/LiveDataContext.mjs';
export default function UserSection() {
  const $ = _c(19);
  const {
    status
  } = useLiveDataContext();
  const pathname = usePathname();
  const isProfileActive = pathname.startsWith("/profile");
  const {
    data: session,
    isPending
  } = useSession();
  const [avatarUrl, setAvatarUrl] = useState(session?.user?.image ?? null);
  const identifiedRef = useRef(false);
  const user = session?.user;
  let t0;
  let t1;
  if ($[0] !== user) {
    t0 = () => {
      if (user && !user.image) {
        getGravatarUrl(user.email).then(setAvatarUrl);
      } else {
        if (user?.image) {
          setAvatarUrl(user.image);
        }
      }
    };
    t1 = [user];
    $[0] = user;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] !== session) {
    t2 = () => {
      if (session?.user?.id && !identifiedRef.current && window.umami) {
        identifiedRef.current = true;
        const provider = session.user.image?.includes("discord") ? "discord" : session.user.image?.includes("github") ? "github" : "unknown";
        window.umami.identify(session.user.id, {
          provider
        });
      }
    };
    $[3] = session;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = session?.user?.id;
  const t4 = session?.user?.image;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = [t3, t4];
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  useEffect(t2, t5);
  if (status === "offline") {
    return null;
  }
  if (isPending) {
    let t6;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="user-section-skeleton" />;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  }
  if (!session?.user) {
    const t6 = pathname === "/sign-in" ? "header-nav-link--active" : "";
    let t7;
    if ($[9] !== t6) {
      t7 = <div className="user-section-content"><SignIn className={t6} /></div>;
      $[9] = t6;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    return t7;
  }
  if (!avatarUrl) {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <div className="user-section-skeleton" />;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  const t6 = `rounded-full ${isProfileActive ? "ring-2 ring-primary" : ""}`;
  const t7 = `${session.user.name ?? "User"} avatar`;
  let t8;
  if ($[12] !== avatarUrl || $[13] !== t6 || $[14] !== t7) {
    t8 = <Link href="/profile" prefetch={false} data-umami-event="nav-profile" className="flex items-center opacity-70 transition-[opacity,transform] hover:opacity-100 active:scale-95"><Image src={avatarUrl} className={t6} alt={t7} width={24} height={24} priority={true} /></Link>;
    $[12] = avatarUrl;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <SignOut />;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t8) {
    t10 = <div className="user-section-content flex items-center gap-3">{t8}{t9}</div>;
    $[17] = t8;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
}